<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serialProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('serialProfile.pageTitle'),
            href: '/admin/product-profiles'
          },
          {
            text: $t('productProfile.ViewAllSerial'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6 ts-space-x-3">
            <Button
              type="success"
              @click.prevent="onExportExcel"
              :loading="exporting"
            >
              <i class="fas fa-file-excel"></i> {{ $t('export') }}
            </Button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <div class="d-flex ts-space-x-3">
                <a-select
                  v-model="location_id"
                  :maxTagCount="1"
                  mode="multiple"
                  :placeholder="$t('all')"
                  style="width: 300px"
                  @change="fetchData()"
                  :options="warehouse"
                >
                </a-select>
                <a-select
                  v-model="sn_status_id"
                  :maxTagCount="1"
                  mode="multiple"
                  :placeholder="$t('all')"
                  style="width: 200px"
                  @change="fetchData()"
                >
                  <a-select-option
                    v-for="(s, index) in serialStatus"
                    :key="index"
                    :value="s.sn_status_id"
                  >
                    {{ s.sn_status }}
                  </a-select-option>
                </a-select>
                <ts-input
                  v-tooltip="$t('productProfile.searchSerial')"
                  v-model="search.text"
                  :placeholder="$t('search')"
                  style="width: 250px"
                  class="inline-block"
                />
              </div>
            </div>
          </div>
        </div>
        <ts-loading-banner :loading="loading" class="ts-overflow-x-scroll">
          <table class="ts-w-full ts-mt-3">
            <thead>
              <tr>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.serial') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.orgSerial') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.refPurchaseInvoice#') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.purchaseInvoiceDate') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.group') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.productName') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.imei') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.engineNumber') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.grade') }}
                </th>
                <!-- <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24">
                  {{ $t('productProfile.productType') }}
                </th> -->
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-40 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.originalWarehouse') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-40 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.warehouse') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32 ts-whitespace-no-wrap"
                >
                  {{ $t('productProfile.status') }}
                </th>
                <th
                  class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-8 ts-whitespace-no-wrap"
                >
                  {{ $t('actions') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(r, index) in serialResources"
                :key="index"
                class="hover:ts-bg-gray-300"
              >
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.serial_no }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.original_serial }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.invoice_no }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.stock_in_date }}
                </td>

                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{
                    r.product.group ? r.product.group.pro_group_name_en : null
                  }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.product.product_name_en }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.imei }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.engine_number }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.product_grade }}
                </td>
                <!-- <td class="ts-py-1 ts-px-2">
                  {{ r.product.type.product_type_en }}
                </td> -->
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.stock_in ? r.stock_in.location.location_name_en : '' }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.location_name_en }}
                </td>
                <td class="ts-py-1 ts-px-2 ts-whitespace-no-wrap">
                  {{ r.sn_status }}
                </td>
                <!-- <td class="ts-py-1 ts-px-2">{{ r.qc_by_user ? r.qc_by_user.employee_name_en : '' }}</td> if conflict 
                <td class="ts-py-1 ts-px-2">{{ r.qc_date }}</td> -->
                <td
                  class="ts-py-1 ts-px-2 ts-text-center ts-space-x-3 ts-whitespace-no-wrap"
                >
                  <a href="#" v-tooltip="$t('productProfile.uploadPhoto')" @click.prevent="attachFile(r)">
                      <i class="fas fa-image"></i>
                    </a>
                  <a
                    href="#"
                    v-tooltip="$t('productProfile.viewHistory')"
                    @click.prevent="showHistory(r)"
                    ><i class="fas fa-eye"></i
                  ></a>
                  <a
                    href="#"
                    v-if="r.allow_edit"
                    v-tooltip="$t('productProfile.editImei')"
                    @click.prevent="updateImei(r)"
                    ><i class="fas fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end ts-overflow-x-scroll ts-mt-3">
            <ts-pagination
              v-model="serialPagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
          <a-modal
            v-if="show_history_serial"
            v-model="show_history_serial"
            :title="$t('productProfile.viewHistory')"
            :zIndex="1020"
            :footer="null"
            :maskClosable="false"
            width="70%"
          >
            <ts-loading-banner :loading="show_history_serial_waiting">
              <ViewSerialHistory
                :record="history"
                :movementHistory="movementHistory"
              />
            </ts-loading-banner>
          </a-modal>
          <a-modal
            v-if="show_modal_update_imei_serial"
            v-model="show_modal_update_imei_serial"
            :title="$t('productProfile.editImei')"
            :zIndex="1020"
            :maskClosable="false"
            :okText="$t('save')"
            :cancelText="$t('cancel')"
            :confirmLoading="waiting_update"
            @ok="onSetImei"
            width="400px"
          >
            <ts-loading-banner :loading="update_imei_loading">
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.serial#')
                  }}</label>
                  <input
                    type="text"
                    v-model="model.serial_no"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.orgSerial')
                  }}</label>
                  <input
                    type="text"
                    v-model="model.original_serial"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.imei')
                  }}</label>
                  <input
                    type="text"
                    v-model.trim="model.imei"
                    class="form-control"
                  />
                  <div class="validate" v-if="errors.has('imei')">
                    {{ errors.first('imei') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.engineNumber')
                  }}</label>
                  <input
                    type="text"
                    v-model.trim="model.engine_number"
                    class="form-control"
                  />
                  <div class="validate" v-if="errors.has('engine_number')">
                    {{ errors.first('engine_number') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs required">{{
                    $t('productProfile.productGrade')
                  }}</label>
                  <select class="form-control" v-model="model.product_grade">
                    <option
                      v-for="(g, index) in grades"
                      :key="index"
                      :value="g.grade"
                      >{{ g.grade }}</option
                    >
                  </select>
                  <div class="validate" v-if="errors.has('product_grade')">
                    {{ errors.first('product_grade') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs required">{{
                    $t('productProfile.qcBy')
                  }}</label>
                  <a-select
                    show-search
                    v-model.number="model.qc_by"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="handleSearchEmployee"
                    :defaultActiveFirstOption="true"
                    class="ts-w-full"
                    :disabled="true"
                  >
                    <a-select-option
                      v-for="emp in employees"
                      :key="emp.employee_id"
                    >
                      {{ emp.employee_name_en }}
                    </a-select-option>
                  </a-select>
                  <div class="validate" v-if="errors.has('qc_by')">
                    {{ errors.first('qc_by') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.remark')
                  }}</label>
                  <textarea
                    rows="3"
                    class="form-control"
                    v-model="model.qc_remarks"
                  ></textarea>
                  <div class="validate" v-if="errors.has('qc_remarks')">
                    {{ errors.first('qc_remarks') }}
                  </div>
                </div>
              </div>
            </ts-loading-banner>
          </a-modal>
          <a-modal
            :title="$t('pdf')"
            width="500px"
            v-model="show_pdf"
            :footer="null"
            @cancel="fetchData()"
          >
            <ts-preview-pdf v-model="waiting_update" :src="src" />
          </a-modal>
          <a-modal
            v-if="show_upload_photo"
            v-model="show_upload_photo"
            :title="$t('productProfile.serialPhoto')"
            :zIndex="1020"
            :footer="null"
            :maskClosable="false"
            width="50%"
          >
            <ts-loading-banner :loading="show_upload_photo_waiting">
              <div class="ts-bg-gray-100 ts-mb-3">
                <h5 class="ts-p-2">Serial: {{ photos.serial_no }}</h5>
              </div>
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('productProfile.attachmentFile') }}</legend>
                  <UploadPhoto v-model="model" :photos="photos" />
                </fieldset>
              </form>
              <div class="ts-flex ts-text-right ts-mt-4">
                <div class="col-md-12 ts-space-x-2 ts-flex ts-justify-end">
                  <ts-button @click.prevent="onCancel">{{
                    $t('cancel')
                  }}</ts-button>
                  <ts-button
                    color="primary"
                    v-if="!isUpdate"
                    :waiting="waiting"
                    :disabled="
                      !isAllUploaded || model.attach_file_list.length == 0
                    "
                    @click.prevent="savePhoto"
                    >{{ $t('save') }}</ts-button
                  >
                  <ts-button
                    v-if="isUpdate"
                    color="primary"
                    :disabled="
                      !isAllUploaded || model.attach_file_list.length == 0
                    "
                    @click.prevent="onUpdate"
                    :waiting="waiting"
                    >{{ $t('update') }}</ts-button
                  >
                </div>
              </div>
            </ts-loading-banner>
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce, trim } from 'lodash'
import { Errors } from 'form-backend-validation'
import ViewSerialHistory from './components/view-serial-history.vue'
import moment from 'moment'
import UploadPhoto from './components/upload-photo.vue'
import * as FileDownload from 'downloadjs'

export default {
  name: 'productAllSerialList',
  components: {
    ViewSerialHistory,
    UploadPhoto
  },
  data() {
    return {
      src: null,
      show_pdf: false,
      loading: false,
      waiting_update: false,
      waiting: false,
      update_imei_loading: false,
      sn_status_id: [1],
      location_id: [],
      history: [],
      movementHistory: [],
      show_history_serial: false,
      show_modal_update_imei_serial: false,
      show_history_serial_waiting: false,
      show_upload_photo_waiting: false,
      show_upload_photo: false,
      errors: new Errors(),
      dateRange: [
        moment().add(-30, 'days').format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
      ],
      employees: [],
      employeeResources: [],
      search: {
        text: ''
      },
      export_resource_loading: false,
      show_export_form: false,
      exporting: false,
      copied: 'Click to copy serial',
      grades: [],
      model: {
        serial_no: '',
        imei: '',
        qc_remarks: '',
        qc_by: null,
        product_grade: '',
        engine_number: '',
        attach_file_list: []
      }
    }
  },
  computed: {
    ...mapState('product/profile', [
      'serialPagination',
      'serialStatus',
      'edit_data'
    ]),
    serialResources() {
      return this.$store.state.product.profile.serialResources.map(item => {
        return Object.assign(
          {
            allow_edit:
              (item.ref_stock_transfer_id || item.ref_write_off_id) &&
              item.sn_status_id <= 3
                ? false
                : true
          },
          item
        )
      })
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    isAllUploaded() {
      const allFiles = this.model.attach_file_list.length

      const uploadedFile = this.model.attach_file_list.filter(
        u => u.uploaded === true
      )

      return allFiles == uploadedFile.length
    },
    warehouse() {
      return this.$store.state.product.profile.warehouses.map(el => ({
        value: el.location_id,
        label: el.location_name_en,
        is_default: el.pivot.is_default
      }))
    }
  },
  created() {
    this.fetchWarehouseAssigned()
  },
  methods: {
    ...mapActions('product/profile', [
      'fetchSerialStatus',
      'fetchWarehouseAssigned',
      'fetchSerialHistory',
      'setImei',
      'employee',
      'formViewModel'
    ]),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/profile/fetchAllSerial', {
          sn_status_id: this.sn_status_id,
          location_id: this.location_id,
          filter: {
            search: this.search.text,
            sn_status_id: this.sn_status_id,
            date_between: _.join(this.dateRange, ',')
          },
          ...attributes
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    showHistory(record) {
      this.show_history_serial = true
      this.show_history_serial_waiting = true
      this.history = []
      this.fetchSerialHistory(record.serial_no)
        .then(response => {
          this.history = response.data
          this.movementHistory = response.movementHistory
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_history_serial_waiting = false
        })
    },
    updateImei(record) {
      const user = this.$store.state.authUser.user
      this.fetchEmployee()
      this.errors = new Errors()
      this.show_modal_update_imei_serial = true
      this.model.serial_no = record.serial_no
      this.model.original_serial = record.original_serial
      this.model.qc_remarks = record.qc_remarks
      this.model.imei = record.imei
      this.model.product_grade = record.product_grade
      this.model.engine_number = record.engine_number
      this.model.qc_by = user ? user.employee_id : ''
    },
    onSetImei() {
      this.waiting_update = true
      this.src = null
      this.errors = new Errors()
      this.setImei(this.model)
        .then((response) => {
          // this.$toasted.success(response.messages)
          // this.fetchData()
          this.show_pdf = true
          this.src = response.url
          this.show_modal_update_imei_serial = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_update = false
        })
    },
    fetchEmployee() {
      this.update_imei_loading = true
      this.employee()
        .then(async response => {
          this.employees = response.data
          await this.formViewModel({
            fnName: 'productGrade'
          }).then(({ data }) => {
            this.grades = data.productGrade
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.update_imei_loading = false
        })
    },
    handleSearchEmployee(value) {
      let em = this.employees.find(em => em.card_id == value)
      if (em) {
        this.model.qc_by = em.employee_id
      }
    },
    setDefaultWarehouse() {
      this.location_id.push(
        this.$store.state.authUser.user.warehouses.find(
          el => el.pivot.is_default == true
        ).location_id
      )
      this.fetchData()
    },
    fetchWarehouseAssigned() {
      this.$store
        .dispatch('product/profile/fetchWarehouseAssigned')
        .then(() => {
          this.setDefaultWarehouse()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onExportExcel() {
      this.exporting = true
      this.error = new Errors()
      this.$store
        .dispatch('product/profile/exportExcel', {
          location_id: this.location_id,
          sn_status_id: this.sn_status_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
          this.show_export_form = false
          this.clearInput()
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.exporting = false
        })
    },
    attachFile(items) {
      this.show_upload_photo = true
      this.photos = items
    },
    savePhoto() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'product/profile/storePhoto',
          Object.assign({}, this.model, {
            serial_no: this.photos.serial_no
          })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.onCancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onCancel() {
      this.show_upload_photo = false
      this.fetchData()
    },
    clearEdit() {
      this.showForm = false
    },
    onCopy: function(e) {
      this.copied = 'Copied'
      setTimeout(() => {
        this.copied = 'Click to copy serial'
      }, 1000)
    },
    onError: function(e) {
      this.copied = 'Failed Copied'
    }
  },
  watch: {
    'search.text': debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchSerialStatus()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/profile/SET_RESET_SERIAL_PAGE')
    this.$store.commit('product/profile/RESET_RESOURCES_SERIAL')
    next()
  }
}
</script>
